import "firebase/firestore"
import { useFirestoreCollectionData, useFirestore } from "reactfire"

const EMPTY_LIST = []

const useLocations = () => {
  const collection = useFirestore().collection("locations")
  // const query = collection.orderBy("zone", "asc").orderBy("name", "asc")
  const query = collection.orderBy("name", "asc")
  const { status, data } = useFirestoreCollectionData(query, {
    idField: "id",
  })

  const addLocation = (values) => collection.add(values)
  const updateLocation = (id, values) =>
    collection.doc(id).set(values, { merge: true })
  const removeLocation = (id) => collection.doc(id).delete()

  return {
    locations: data || EMPTY_LIST,
    isLoading: status === "loading",
    addLocation,
    updateLocation,
    removeLocation,
  }
}

export { useLocations }
